import { useNetwork } from "../../utils/useNetwork";

function NetworkStatus() {
    const { online, isSlow, isGood } = useNetwork();

    if (isGood) {
        return null;
    }

    return (
        <div className="p-3">
            <div className={`text-center p-2 rounded ${online && isSlow ? 'bg-warning-subtle' : 'bg-danger-subtle'}`}>
                {online && isSlow ? (
                    <p className="color-dark m-0">
                        Your network connection appears slow. Some features may take longer to load.
                    </p>
                ) : (
                    <p className="color-dark m-0">
                        You are currently offline. Please check your internet connection.
                    </p>
                )}
            </div>
        </div>
    );
}

export default NetworkStatus;
